<template>
  <sys-dialog
    v-model="dialog"
    ocultar-acoes
    largura="1200"
  >
    <template #ativador>
      <div class="d-flex align-center" style="max-width: 105px">
        <p class="ma-0 text-truncate" :title="reduceArrayParaString">{{ reduceArrayParaString }}</p>

        <v-btn icon small :disabled="disabled" class="ml-n1" @click="dialog = ! dialog">
          <v-icon small>mdi-information-outline</v-icon>
        </v-btn>
      </div>
    </template>

    <template #titulo>
      <div class="d-flex w-full align-center">
        <h4 class="title">{{ texto_titulo_dialog }}</h4>

        <v-spacer />

        <span class="subtitle-2 mt-1 ml-5">{{items.length}} Pedido{{items.length > 1 ? 's' : ''}} em Aberto</span>

        <v-btn icon class="ml-6 mr-1" @click="dialog = ! dialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </template>

    <template #default>
      <v-data-table
        height="400px"
        :headers="headers"
        :items="items"
        class="table-full-screen"
        :items-per-page="-1"
        hide-default-footer
        fixed-header
      >
        <template #top>
          <div class="mb-2">
            <span id="txt-titulo-tabela" class="ml-1">
              <span class="font-weight-bold">PRODUTO: </span>
              <slot name="nome-produto">{{produto.nome_produto}}</slot>
            </span>
          </div>
        </template>

        <template #item.pcompra="{item}">
          {{Helpers.formatarValorComCasas(item.pcompra, 4)}}
        </template>

        <template #item.qtde="{item}">
          {{Helpers.formatarValor(item.qtde)}}
        </template>

        <template #item.qtde_pendente="{item}">
          {{Helpers.formatarValor(item.qtde_pendente)}}
        </template>

        <template #item.qtde_entregue="{item}">
          {{Helpers.formatarValor(item.qtde_entregue)}}
        </template>

        <template #item.qtde_entregue="{item}">
          {{Helpers.formatarValor(item.qtde_entregue)}}
        </template>

        <template #item.data_entrega="{item}">
          <span v-if="item.data_entrega">{{ item.data_entrega }}</span>
          <span v-else class="text-gray-300">Sem Entrega</span>
        </template>
      </v-data-table>
    </template>
  </sys-dialog>
</template>

<script>
import SysDialog from "../../padraoDeLayout/SysDialog";
import RequisicaoAPI from "../../../api/Requisicao";
import {mapGetters} from "vuex";

export default {
  name: "PedidosEmTransitoDialog",
  components: {SysDialog},
  props: {
    produto: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buscar_apenas_pedidos_do_array: {
      type: Boolean,
      default: false
    },
    texto_titulo_dialog: {
      type: String,
      default: "Lista de pedidos em Aberto"
    }
  },
  data: () => ({
    dialog: false,
    headers: [
      {text: 'Id da Solicitação', value: 'id_solicitacao'},
      {text: 'Data da Solicitação', value: 'data_solicitacao'},
      {text: 'Ordem de Compra', value: 'ordem_compra'},
      {text: 'Filial', value: 'idfilial'},
      {text: 'Item', value: 'item'},
      {text: 'Preço de Compra', value: 'pcompra'},
      {text: 'Unidade de Medida', value: 'unidade_medida'},
      {text: 'Qtde. Comprada', value: 'qtde'},
      {text: 'Qtde. Pendente', value: 'qtde_pendente'},
      {text: 'Qtde. Entregue', value: 'qtde_entregue'},
      {text: 'Data da Últ. Entrega', value: 'data_entrega'},
    ],
    items: [],
  }),
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
    reduceArrayParaString() {
      if (!this.produto.lista_pedidos_em_aberto) {
        return;
      }

      return this.produto.lista_pedidos_em_aberto.join(', ');
    }
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.getPedidosEmAberto()
      }
    }
  },
  methods: {
    getPedidosEmAberto() {
      if (this.items.length > 0) {
        return;
      }

      const parametros = {
        produtos: this.produto.produtos,
        pedidos: this.buscar_apenas_pedidos_do_array ? this.produto.lista_pedidos_em_aberto : undefined
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RequisicaoAPI.getRequisicaoPendenteProduto(this.produto.id_grupo || this.grupoCompra, this.produto.id_produto, parametros)
          .then(resp => {
            const {token, requisicoes} = resp.data
            localStorage.token = token
            this.items = requisicoes
          }).catch(() => this.Helpers.logout())
      );
    }
  }
}
</script>

<style scoped>
#txt-titulo-tabela {
  font-size: 15px;
}
</style>
